import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Textarea from 'react-textarea-autosize';

import styles from './SocialIcon.scss';
import propTypeStyleLabel from '../../domains/styling/config/editorBlock/PropTypes/styleLabel';
import { socialButtonPropType } from '../questions/SocialQuestion/socialQuestionPropTypes';
import sanitizeInputNodeValue from '../../utils/sanitizeInputNodeValue';

const SocialIcon = ({
  button,
  config: { className, color },
  showLabel,
  isFullWidthLabel,
  disabled,
  styleLabel,
  editable,
  onSubmit,
}) => {
  const [anchorValue, setAnchorValue] = useState(button.anchor);
  const shouldHideLabel = !editable && !anchorValue;

  return (
    <div className={styles.container}>
      <a
        href={disabled ? null : button.url}
        target="_blank"
        className={styles.link}
      >
        <span className={`${className} ${styles.icon}`} style={{ color }} />
        {showLabel &&
          !shouldHideLabel && (
            <Textarea
              disabled={!editable}
              value={anchorValue}
              onChange={ev =>
                setAnchorValue(sanitizeInputNodeValue(ev.target.value))
              }
              onBlur={() =>
                onSubmit({
                  ...button,
                  anchor: anchorValue,
                })
              }
              className={
                isFullWidthLabel ? styles.fullWidthLabel : styles.label
              }
              style={styleLabel}
            />
          )}
      </a>
    </div>
  );
};

SocialIcon.propTypes = {
  button: socialButtonPropType.isRequired,
  config: PropTypes.shape({
    className: PropTypes.string,
    label: PropTypes.string,
    color: PropTypes.string,
  }).isRequired,
  editable: PropTypes.bool,
  disabled: PropTypes.bool,
  showLabel: PropTypes.bool,
  isFullWidthLabel: PropTypes.bool,
  styleLabel: propTypeStyleLabel,
  onSubmit: PropTypes.func.isRequired,
};

export default SocialIcon;
